import { initialize } from 'modules/notificationSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useNotificationPage = () => {
  const dispatch = useDispatch();

  const { loading, error } = useSelector(({ notification }) => notification);

  useEffect(() => {
    return () => {
      dispatch(initialize());
    };
  }, [dispatch]);

  return { loading, error };
};

export default useNotificationPage;
